<script lang="ts" setup>
  import { closeOutline, close } from 'ionicons/icons'

  const props = withDefaults(
    defineProps<{
      color?: string
      size?: string
      outline?: boolean
    }>(),
    {
      color: 'var(--color-base-black)',
      size: '24px',
      outline: true
    }
  )

  defineEmits<{ (e: 'click'): void }>()
</script>

<template>
  <GIcon
    :color="color"
    :icon="props.outline ? closeOutline : close"
    :size="size"
    aria-label="close"
    class="close-button"
    tabindex="0"
    @click="$emit('click')"
    @keydown.enter="$emit('click')"
  />
</template>

<style lang="scss" scoped>
  .close-button {
    cursor: pointer;
  }
</style>
